export const environment = {
  production: true,
  buildId: '3497387970822411',
  configFile: 'config.json',
};
